import Accordion from 'scripts/components/basic/Accordion.vue';
import AccordionGroup from 'scripts/components/basic/AccordionGroup.vue';
import Icon from 'scripts/components/basic/Icon.vue';
import ScrollButton from 'scripts/components/buttons/ScrollButton.vue';

import ProductTop from 'scripts/components/product/ProductTop.vue';
import ProductBottom from 'scripts/components/product/ProductBottom.vue';
import ProductSubHeader from 'scripts/components/product/ProductSubHeader.vue';
import ProductCard from 'scripts/components/product/ProductCard.vue';
import BeforeAfter from 'scripts/components/product/BeforeAfter.vue';
import SubCollectionTile from 'scripts/components/collection/SubCollectionTile.vue';

import ChildProductsSection from 'scripts/components/product/ChildProductsSection.vue';

import SetProductsSection from 'scripts/components/product/SetProductsSection.vue';

import Slideshow from 'scripts/components/sections/Slideshow.vue';
import CollectionSlider from 'scripts/components/collection/CollectionSlider.vue';
import CollectionSliderWrapper from 'scripts/components/collection/CollectionSliderWrapper.vue';
import FeaturedCategories from 'scripts/components/sections/FeaturedCategories.vue';
import VideoComponent from 'scripts/components/sections/VideoComponent.vue';
import PageHero from 'scripts/components/sections/PageHero.vue';
import DistributorLocator from 'scripts/components/sections/DistributorLocator.vue';
import FranchiseeBanner from 'scripts/components/sections/FranchiseeBanner.vue';

/**
 * Deferred components
 *
 * These components will only load if they are rendered by markup. Use
 * for components that don't load on every page.
 *
 * i.e. below the fold components, landing page components, etc.
 */
// const AsyncComponent = () => import('scripts/components/category/AsyncComponent.vue')

export default {
  Accordion,
  AccordionGroup,
  Icon,
  ScrollButton,
  ProductTop,
  ProductBottom,
  ProductSubHeader,
  ProductCard,
  BeforeAfter,
  SubCollectionTile,
  ChildProductsSection,
  SetProductsSection,
  Slideshow,
  CollectionSlider,
  CollectionSliderWrapper,
  FeaturedCategories,
  VideoComponent,
  PageHero,
  DistributorLocator,
  FranchiseeBanner
};